import { URLS } from 'constants/urls'
import { Route, Routes } from 'react-router-dom'
import { StopSaleAdd } from './components/StopSales/components/StopSaleAdd'
import { StopSales } from './components/StopSales'
import { Vehicles } from './components/Vehicles'
import { VehicleAdd } from './components/Vehicles/components/VehicleAdd'
import { Equipments } from './components/Equipments/Equipments'
import { EquipmentAdd } from './components/Equipments/components/EquipmentAdd/EquipmentAdd'
import { VehicleEdit } from './components/Vehicles/components/VehicleEdit'
import { EquipmentDetails } from './components/Equipments/components/EquipmentDetails'
import { PriceLists } from './components/PriceLists'
import { PriceListAdd } from './components/PriceLists/components/PriceListAdd'
import { NotFound } from 'ui/molecules/NotFound'
import { PriceListDetails } from './components/PriceLists/components/PriceListDetails'
import { Rates } from './components/PriceLists/components/Rates'
import { StopSaleEdit } from './components/StopSales/components/StopSaleEdit'
import { useDisableMenuItems } from 'hooks/useDisableMenuItems'
import { ProtectedRoute } from 'routes/ProtectedRoute'
import { MENU_NAMES } from 'texts/menuNames'
import { ReactNode } from 'react'

export const Fleet = () => {
  const { disableMenuItem } = useDisableMenuItems()

  const protectRoute = (children: ReactNode, menuName: string) => (
    <ProtectedRoute isUnavailable={disableMenuItem(menuName)}>
      {children}
    </ProtectedRoute>
  )

  return (
    <Routes>
      <Route
        path={`${URLS.VEHICLES}/:companyId`}
        element={protectRoute(<Vehicles />, MENU_NAMES.VEHICLES)}
      />
      <Route
        path={`${URLS.VEHICLES}`}
        element={protectRoute(<Vehicles />, MENU_NAMES.VEHICLES)}
      />
      <Route
        path={`${URLS.VEHICLES}/:companyId/add`}
        element={protectRoute(<VehicleAdd />, MENU_NAMES.VEHICLES)}
      />
      <Route
        path={`${URLS.VEHICLES}/add`}
        element={protectRoute(<VehicleAdd />, MENU_NAMES.VEHICLES)}
      />
      <Route
        path={`${URLS.VEHICLES}/:companyId/:id/edit`}
        element={protectRoute(<VehicleEdit />, MENU_NAMES.VEHICLES)}
      />
      <Route
        path={`${URLS.STOP_SALES}/:companyId/add`}
        element={protectRoute(<StopSaleAdd />, MENU_NAMES.STOP_SALES)}
      />
      <Route
        path={`${URLS.STOP_SALES}/add`}
        element={protectRoute(<StopSaleAdd />, MENU_NAMES.STOP_SALES)}
      />
      <Route
        path={`${URLS.STOP_SALES}`}
        element={protectRoute(<StopSales />, MENU_NAMES.STOP_SALES)}
      />
      <Route
        path={`${URLS.STOP_SALES}/:companyId`}
        element={protectRoute(<StopSales />, MENU_NAMES.STOP_SALES)}
      />
      <Route
        path={`${URLS.STOP_SALES}/:companyId/:id/edit`}
        element={protectRoute(<StopSaleEdit />, MENU_NAMES.STOP_SALES)}
      />
      <Route
        path={`${URLS.EQUIPMENTS}`}
        element={protectRoute(<Equipments />, MENU_NAMES.EQUIPMENTS)}
      />
      <Route
        path={`${URLS.EQUIPMENTS}/:companyId`}
        element={protectRoute(<Equipments />, MENU_NAMES.EQUIPMENTS)}
      />
      <Route
        path={`${URLS.EQUIPMENTS}/:companyId/add`}
        element={protectRoute(<EquipmentAdd />, MENU_NAMES.EQUIPMENTS)}
      />
      <Route
        path={`${URLS.EQUIPMENTS}/add`}
        element={protectRoute(<EquipmentAdd />, MENU_NAMES.EQUIPMENTS)}
      />
      <Route
        path={`${URLS.EQUIPMENTS}/:companyId/:id/edit`}
        element={protectRoute(<EquipmentDetails />, MENU_NAMES.EQUIPMENTS)}
      />
      <Route
        path={`${URLS.PRICE_LIST}/:companyId`}
        element={protectRoute(<PriceLists />, MENU_NAMES.PRICE_LISTS)}
      />
      <Route
        path={`${URLS.PRICE_LIST}`}
        element={protectRoute(<PriceLists />, MENU_NAMES.PRICE_LISTS)}
      />
      <Route
        path={`${URLS.PRICE_LIST}/:companyId/add`}
        element={protectRoute(<PriceListAdd />, MENU_NAMES.PRICE_LISTS)}
      />
      <Route
        path={`${URLS.PRICE_LIST}/add`}
        element={protectRoute(<PriceListAdd />, MENU_NAMES.PRICE_LISTS)}
      />
      <Route
        path={`${URLS.PRICE_LIST}/:companyId/:priceListId/edit`}
        element={protectRoute(<PriceListDetails />, MENU_NAMES.PRICE_LISTS)}
      />
      <Route
        path={`${URLS.PRICE_LIST}/:companyId/:priceListId/rates`}
        element={protectRoute(<Rates />, MENU_NAMES.PRICE_LISTS)}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
